
import moment from 'moment';

import {
  Status
} from '../types';

function lastStatus(history: Status[], status?: string|string []|undefined, dontMatch?: boolean|undefined): Status|null {
  if (history.length == 0) return null;
  let last: Status|null = null;
  let match = !dontMatch;

  const allStatus = status instanceof Array ? status : [status];

  history.forEach((item) => {
    if (!last && !status) {
      last = item;
      return;
    }
    if (!last && status && match && (allStatus.indexOf(item.status) > -1)) {
      last = item;
      return;
    }
    if (!last && status && !match && item.status && (allStatus.indexOf(item.status) == -1)) {
      last = item;
      return;
    }

    if (!last) return;

    if (moment(item.updated_at) > moment(last.updated_at)) {
      if (status && match && (allStatus.indexOf(item.status) > -1)) {
        last = item;
      }
      else if (status && !match && item.status && (allStatus.indexOf(item.status) == -1)) {
        last = item;
      }
      if (!status) last = item;
    }
  })

  return last;
}

export default lastStatus;